import * as Mui from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import useOperationTranslation from "../../hooks/useOperationTranslation";
import { customTheme } from "../../../../config/theme/MuiTheme";

interface Props {
    open: boolean;
    onClose: () => void;    
    damageId: any;
    onCloseDamage: () => void;
    updateDatasourceDanger: () => void;
};
const CloseDamageConfirmation = (props: Props) => {
    const t = useOperationTranslation();

    return(
        <Mui.Dialog
            open={props.open} 
            onClose={props.onClose} 
            fullWidth
            maxWidth="sm" 
        >
            <Mui.DialogTitle>
                <Mui.Grid container spacing={1}>
                    <Mui.Grid item color={customTheme.palette.accent.main}>
                        <InfoIcon color="inherit" />
                    </Mui.Grid>
                    
                    <Mui.Grid item>
                        <Mui.Typography variant="h5">
                            {t("damageList.dialogs.closeConfirmation.title")}
                        </Mui.Typography>
                    </Mui.Grid>

                    <Mui.Grid item marginLeft={"auto"} >
                        <Mui.IconButton onClick={props.onClose} style={{padding: "0px"}} >
                            <CloseIcon />
                        </Mui.IconButton>
                    </Mui.Grid>
                </Mui.Grid>
            </Mui.DialogTitle>
            <Mui.DialogContent>
                <Mui.Typography>
                    {t("damageList.dialogs.closeConfirmation.body1")}
                </Mui.Typography>

                <Mui.Typography pt="10px">
                    {t("damageList.dialogs.closeConfirmation.body2")}
                </Mui.Typography>
            </Mui.DialogContent>
            
            <Mui.DialogActions>
                <Mui.Button variant="outlined" size="smallPlus" onClick={props.onClose}>
                    <Mui.Typography color={'accent'} variant="h6">
                        {t("damageList.dialogs.closeConfirmation.btnCancel")}
                    </Mui.Typography>
                </Mui.Button>

                <Mui.Button type="submit" onClick={props.onCloseDamage} size="smallPlus">
                    <Mui.Typography color={'accent'} variant="h6">
                        {t("damageList.dialogs.closeConfirmation.btnClose")}
                    </Mui.Typography>
                </Mui.Button>
            </Mui.DialogActions>
        </Mui.Dialog>
    )
}
export default CloseDamageConfirmation;